// extracted by mini-css-extract-plugin
export default {"recos":"J7-z","productCardOverride":"K7-z","rowHasBadge":"L7-z"};